import React from "react";
import "./Leadership.css";

import exec1 from "../../Assets/images/president.png";
import exec2 from "../../Assets/images/vice-president.jpg";
import exec3 from "../../Assets/images/general-secretary.png";
import exec4 from "../../Assets/images/financial-secretary.png";
import exec5 from "../../Assets/images/treasure.png";
import exec6 from "../../Assets/images/legal-secretary.png";
import exec7 from "../../Assets/images/organizing-secretary.png";
import exec8 from "../../Assets/images/deputy-general-secretary.png";
import exec9 from "../../Assets/images/chaplain.png";

const president = {
  name: "Mr. Daniel Blamoh Nah",
  position: " UGAAL - President",
  tenure: "2023 - Present",
  bio: `Daniel Blamoh Nah profile in brief:

Daniel Blamoh Nah – Lead Capacity Builder, Public Policy Analyst, Financial
Management, Taxation, Auditing, Accounting, Data Analysis, Community Development
and Project Management Consultant.

With over seventeen (17) years’ experience in various industries, including community
development, Auditing, Banking, Education, Automobile, Petroleum, Mining, Project
management, Financial Management, Accounting, Human Resource, Shipping, and industrial
manufacturing; Daniel runs the day-to-day operations of the firm. His wealth of experience in
Accounting, Financial and Asset Management, Withholding and Corporate taxation has been
utilized to represent clients during tax audits both here in West Africa (Liberia, Ghana, Sierra
Leone), and the United States.

Prior to starting ALI, Daniel worked as Project Manager at Grace For Dover (GFD) in Dover
Delaware USA where he designed and successfully implemented a multimillion dollar youth
empowerment project. Daniel also served as personal finance supplementary instructor at
Delaware State University in the United States. He also worked as Inventory Control and Quality
Assurance specialist at Amazon in Middletown Delaware USA.

In Africa, Daniel recently served as Business, Finance & Administration Advisor - LTTA –
Contractor for USAID GHSC-PSM Chemonics International / Akesis Global Health Inc - under
the Liberia Central Medical Store - MOH.

Before then traveling to the USA, Daniel served as Finance Manager for Liberia and Sierra
Leone at Boart Longyear Corporation. He also served as Credit Controller and Treasurer, and
Chief Accountant at Total Liberia Inc.

Daniel has worked as Chief Internal Auditor for LEAP and as Chief Accountant for Toyota
Liberia Inc. In these roles, he advised top management on key initiatives-providing them with
the necessary tools that enable them to make critical decisions that positively impacted their
organizations’ operations. Daniel also worked in strategic financial consulting roles with private
enterprises such as Fantini Research Publication and Bloomberg in the United States. He worked
closely with top management to implement some global corporations restructuring projects and
served as the lead financial and data analyst that provided senior management with up-to-date
financial performance reporting and information that aided key decision-making.

Daniel holds two Masters degrees: A Master in Business Administration with emphasis in
Corporate Finance from Delaware State University USA, and a Master in Community
Development Policy and Practice with emphasis in Community Project Management from the
University of New Hampshire, USA. Daniel also holds a Combined Major Bachelor of Art
degree in Accounting and Sociology from the University of Ghana, Legon. He also holds a
diploma in Accounting and Management from AHEAD institute, Ghana. Daniel is currently a
candidate for CPA certification.

Mr. Daniel Blamoh Nah 
Tel- +231881924553 / +231776609125 
Email: db_nah@yahoo.com`,
  image: exec1,
};

const executives = [
  {
    id: 2,
    name: "Mrs. Uomah  B. Witherspoon",
    position: "UGAAL – Vice President",
    tenure: "2023 - Present",
    bio: " Uomah brings strategic vision and strong organizational skills, with a background in project management and alumni engagement.",
    image: exec2,
  },
  {
    id: 3,
    name: "Amb. Garmondeh Yebleh",
    position: "UGAAL - Secretary General",
    tenure: "2023 – Present",
    bio: " Garmondeh oversees administration and communication, ensuring transparency and effective coordination within the association.",
    image: exec3,
  },
  {
    id: 4,
    name: "Mrs. Jackie Eastman ",
    position: "GAAL - Financial Secretary",
    tenure: "2023 – Present",
    bio: "  Jackie oversees administration and communication, ensuring transparency and effective coordination within the association.",
    image: exec4,
  },
  {
    id: 5,
    name: "Mr. Paylay Halay ",
    position: "UGAAL - Treasurer",
    tenure: "2023 – Present",
    bio: " Paylay oversees administration and communication, ensuring transparency and effective coordination within the association.",
    image: exec5,
  },
  {
    id: 6,
    name: "Atty. Thomas S.W. Neufville",
    position: "UGAAL – Legal Secretary",
    tenure: "2023 – Present",
    bio: " Thomas oversees administration and communication, ensuring transparency and effective coordination within the association.",
    image: exec6,
  },
  {
    id: 7,
    name: "Mrs. Joanna Washington Davis",
    position: "UGAAL - Organizing Secretary",
    tenure: "2023 – Present",
    bio: " Joanna is an accomplished Chief Operations Officer with over 11 years of progressive experience spanning management, sales, and customer service. She is a dynamic and results-driven leader known for her strong communication skills, sharp analytical thinking, and ability to solve complex operational challenges with precision and efficiency.",
    image: exec7,
  },
  {
    id: 8,
    name: "Ms. Yondeh M. Moore",
    position: "UGAAL - Deputy Secretary General",
    tenure: "2023 – Present",
    bio: "Yondeh oversees administration and communication, ensuring transparency and effective coordination within the association.",
    image: exec8,
  },
  {
    id: 9,
    name: "Mr. Willie K. Johnson",
    position: "UGAAL - Chaplain",
    tenure: "2023 – Present",
    bio: " Willie oversees administration and communication, ensuring transparency and effective coordination within the association.",
    image: exec9,
  },
 
];

const committees = [
  "Advisory Council",
  "Applied Research & Man Power Development Committee",
  "Social Educative Programs & Entertainment Committee Members",
  "Welfare & Membership Mobilization Committee Members",
  "Publicity Committee Members",
  "Finance & Investment Committee Members",
  "Liaison officers between UGAA & Parent Association in Ghana",
  "Senior Advisor to the President",
  "The Association International Relations Committee ",
];

const Leadership = () => {
  return (
    <section className="leadership-page">
      <h1 className="leadership-heading">The Association’s Current Leadership</h1>

      {/* President */}
      <div className="president-wrapper">
        <div className="president-card">
          <img
            src={president.image}
            alt={president.name}
            className="president-photo"
          />
          <h2>{president.name}</h2>
          <p className="position">{president.position}</p>
          <p className="tenure">Tenure: {president.tenure}</p>
          <p className="bio">{president.bio}</p>
        </div>
      </div>

      {/* Other Executives */}
      <div className="executives-grid">
        {executives.map((exec) => (
          <div key={exec.id} className="executive-card">
            <img
              src={exec.image}
              alt={exec.name}
              className="executive-photo"
            />
            <h3>{exec.name}</h3>
            <p className="position">{exec.position}</p>
            <p className="tenure">Tenure: {exec.tenure}</p>
            <p className="bio">{exec.bio}</p>
          </div>
        ))}
      </div>

      {/* Committees */}
      <div className="committees-section">
        <h2>Standing Committees</h2>
        <ul>
          {committees.map((committee, index) => (
            <li key={index}>{committee}</li>
          ))}
        </ul>
      </div>

      {/* Constitution
      <div className="constitution-section">
        <h2>Association Constitution</h2>
        <p>
          Download and review the official constitution governing the alumni
          association.
        </p>
        <a
          href="/documents/association-constitution.pdf"
          download
          className="download-btn"
        >
          Download Constitution (PDF)
        </a>
      </div> */}
    </section>
  );
};

export default Leadership;
